// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/ona_intelligence.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message gitpod.v1.CreateOrganizationLLMConfigurationRequest
 */
export class CreateOrganizationLLMConfigurationRequest extends Message<CreateOrganizationLLMConfigurationRequest> {
  /**
   * organization_id is the ID of the organization to configure
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * api_key is the plaintext Anthropic API key to encrypt and store
   *
   * @generated from field: string api_key = 2;
   */
  apiKey = "";

  constructor(data?: PartialMessage<CreateOrganizationLLMConfigurationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateOrganizationLLMConfigurationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "api_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateOrganizationLLMConfigurationRequest {
    return new CreateOrganizationLLMConfigurationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateOrganizationLLMConfigurationRequest {
    return new CreateOrganizationLLMConfigurationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateOrganizationLLMConfigurationRequest {
    return new CreateOrganizationLLMConfigurationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateOrganizationLLMConfigurationRequest | PlainMessage<CreateOrganizationLLMConfigurationRequest> | undefined, b: CreateOrganizationLLMConfigurationRequest | PlainMessage<CreateOrganizationLLMConfigurationRequest> | undefined): boolean {
    return proto3.util.equals(CreateOrganizationLLMConfigurationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateOrganizationLLMConfigurationResponse
 */
export class CreateOrganizationLLMConfigurationResponse extends Message<CreateOrganizationLLMConfigurationResponse> {
  /**
   * configuration contains metadata about the stored configuration
   *
   * @generated from field: gitpod.v1.OrganizationLLMConfiguration configuration = 1;
   */
  configuration?: OrganizationLLMConfiguration;

  constructor(data?: PartialMessage<CreateOrganizationLLMConfigurationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateOrganizationLLMConfigurationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "configuration", kind: "message", T: OrganizationLLMConfiguration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateOrganizationLLMConfigurationResponse {
    return new CreateOrganizationLLMConfigurationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateOrganizationLLMConfigurationResponse {
    return new CreateOrganizationLLMConfigurationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateOrganizationLLMConfigurationResponse {
    return new CreateOrganizationLLMConfigurationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateOrganizationLLMConfigurationResponse | PlainMessage<CreateOrganizationLLMConfigurationResponse> | undefined, b: CreateOrganizationLLMConfigurationResponse | PlainMessage<CreateOrganizationLLMConfigurationResponse> | undefined): boolean {
    return proto3.util.equals(CreateOrganizationLLMConfigurationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateOrganizationLLMConfigurationRequest
 */
export class UpdateOrganizationLLMConfigurationRequest extends Message<UpdateOrganizationLLMConfigurationRequest> {
  /**
   * organization_id is the ID of the organization to update
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * api_key is the plaintext Anthropic API key to encrypt and store (optional)
   *
   * @generated from field: optional string api_key = 2;
   */
  apiKey?: string;

  constructor(data?: PartialMessage<UpdateOrganizationLLMConfigurationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateOrganizationLLMConfigurationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "api_key", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateOrganizationLLMConfigurationRequest {
    return new UpdateOrganizationLLMConfigurationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateOrganizationLLMConfigurationRequest {
    return new UpdateOrganizationLLMConfigurationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateOrganizationLLMConfigurationRequest {
    return new UpdateOrganizationLLMConfigurationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateOrganizationLLMConfigurationRequest | PlainMessage<UpdateOrganizationLLMConfigurationRequest> | undefined, b: UpdateOrganizationLLMConfigurationRequest | PlainMessage<UpdateOrganizationLLMConfigurationRequest> | undefined): boolean {
    return proto3.util.equals(UpdateOrganizationLLMConfigurationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateOrganizationLLMConfigurationResponse
 */
export class UpdateOrganizationLLMConfigurationResponse extends Message<UpdateOrganizationLLMConfigurationResponse> {
  /**
   * configuration contains metadata about the stored configuration
   *
   * @generated from field: gitpod.v1.OrganizationLLMConfiguration configuration = 1;
   */
  configuration?: OrganizationLLMConfiguration;

  constructor(data?: PartialMessage<UpdateOrganizationLLMConfigurationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateOrganizationLLMConfigurationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "configuration", kind: "message", T: OrganizationLLMConfiguration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateOrganizationLLMConfigurationResponse {
    return new UpdateOrganizationLLMConfigurationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateOrganizationLLMConfigurationResponse {
    return new UpdateOrganizationLLMConfigurationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateOrganizationLLMConfigurationResponse {
    return new UpdateOrganizationLLMConfigurationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateOrganizationLLMConfigurationResponse | PlainMessage<UpdateOrganizationLLMConfigurationResponse> | undefined, b: UpdateOrganizationLLMConfigurationResponse | PlainMessage<UpdateOrganizationLLMConfigurationResponse> | undefined): boolean {
    return proto3.util.equals(UpdateOrganizationLLMConfigurationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetOrganizationLLMConfigurationRequest
 */
export class GetOrganizationLLMConfigurationRequest extends Message<GetOrganizationLLMConfigurationRequest> {
  /**
   * organization_id is the ID of the organization to query
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetOrganizationLLMConfigurationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetOrganizationLLMConfigurationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrganizationLLMConfigurationRequest {
    return new GetOrganizationLLMConfigurationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrganizationLLMConfigurationRequest {
    return new GetOrganizationLLMConfigurationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrganizationLLMConfigurationRequest {
    return new GetOrganizationLLMConfigurationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrganizationLLMConfigurationRequest | PlainMessage<GetOrganizationLLMConfigurationRequest> | undefined, b: GetOrganizationLLMConfigurationRequest | PlainMessage<GetOrganizationLLMConfigurationRequest> | undefined): boolean {
    return proto3.util.equals(GetOrganizationLLMConfigurationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetOrganizationLLMConfigurationResponse
 */
export class GetOrganizationLLMConfigurationResponse extends Message<GetOrganizationLLMConfigurationResponse> {
  /**
   * configuration contains metadata about the stored configuration
   *
   * @generated from field: gitpod.v1.OrganizationLLMConfiguration configuration = 1;
   */
  configuration?: OrganizationLLMConfiguration;

  constructor(data?: PartialMessage<GetOrganizationLLMConfigurationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetOrganizationLLMConfigurationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "configuration", kind: "message", T: OrganizationLLMConfiguration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrganizationLLMConfigurationResponse {
    return new GetOrganizationLLMConfigurationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrganizationLLMConfigurationResponse {
    return new GetOrganizationLLMConfigurationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrganizationLLMConfigurationResponse {
    return new GetOrganizationLLMConfigurationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrganizationLLMConfigurationResponse | PlainMessage<GetOrganizationLLMConfigurationResponse> | undefined, b: GetOrganizationLLMConfigurationResponse | PlainMessage<GetOrganizationLLMConfigurationResponse> | undefined): boolean {
    return proto3.util.equals(GetOrganizationLLMConfigurationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListOrganizationLLMConfigurationsRequest
 */
export class ListOrganizationLLMConfigurationsRequest extends Message<ListOrganizationLLMConfigurationsRequest> {
  constructor(data?: PartialMessage<ListOrganizationLLMConfigurationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListOrganizationLLMConfigurationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListOrganizationLLMConfigurationsRequest {
    return new ListOrganizationLLMConfigurationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListOrganizationLLMConfigurationsRequest {
    return new ListOrganizationLLMConfigurationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListOrganizationLLMConfigurationsRequest {
    return new ListOrganizationLLMConfigurationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListOrganizationLLMConfigurationsRequest | PlainMessage<ListOrganizationLLMConfigurationsRequest> | undefined, b: ListOrganizationLLMConfigurationsRequest | PlainMessage<ListOrganizationLLMConfigurationsRequest> | undefined): boolean {
    return proto3.util.equals(ListOrganizationLLMConfigurationsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListOrganizationLLMConfigurationsResponse
 */
export class ListOrganizationLLMConfigurationsResponse extends Message<ListOrganizationLLMConfigurationsResponse> {
  /**
   * configurations is the list of organization LLM configurations
   *
   * @generated from field: repeated gitpod.v1.OrganizationLLMConfiguration configurations = 1;
   */
  configurations: OrganizationLLMConfiguration[] = [];

  constructor(data?: PartialMessage<ListOrganizationLLMConfigurationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListOrganizationLLMConfigurationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "configurations", kind: "message", T: OrganizationLLMConfiguration, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListOrganizationLLMConfigurationsResponse {
    return new ListOrganizationLLMConfigurationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListOrganizationLLMConfigurationsResponse {
    return new ListOrganizationLLMConfigurationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListOrganizationLLMConfigurationsResponse {
    return new ListOrganizationLLMConfigurationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListOrganizationLLMConfigurationsResponse | PlainMessage<ListOrganizationLLMConfigurationsResponse> | undefined, b: ListOrganizationLLMConfigurationsResponse | PlainMessage<ListOrganizationLLMConfigurationsResponse> | undefined): boolean {
    return proto3.util.equals(ListOrganizationLLMConfigurationsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteOrganizationLLMConfigurationRequest
 */
export class DeleteOrganizationLLMConfigurationRequest extends Message<DeleteOrganizationLLMConfigurationRequest> {
  /**
   * organization_id is the ID of the organization to delete configuration for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<DeleteOrganizationLLMConfigurationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteOrganizationLLMConfigurationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteOrganizationLLMConfigurationRequest {
    return new DeleteOrganizationLLMConfigurationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteOrganizationLLMConfigurationRequest {
    return new DeleteOrganizationLLMConfigurationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteOrganizationLLMConfigurationRequest {
    return new DeleteOrganizationLLMConfigurationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteOrganizationLLMConfigurationRequest | PlainMessage<DeleteOrganizationLLMConfigurationRequest> | undefined, b: DeleteOrganizationLLMConfigurationRequest | PlainMessage<DeleteOrganizationLLMConfigurationRequest> | undefined): boolean {
    return proto3.util.equals(DeleteOrganizationLLMConfigurationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteOrganizationLLMConfigurationResponse
 */
export class DeleteOrganizationLLMConfigurationResponse extends Message<DeleteOrganizationLLMConfigurationResponse> {
  constructor(data?: PartialMessage<DeleteOrganizationLLMConfigurationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteOrganizationLLMConfigurationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteOrganizationLLMConfigurationResponse {
    return new DeleteOrganizationLLMConfigurationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteOrganizationLLMConfigurationResponse {
    return new DeleteOrganizationLLMConfigurationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteOrganizationLLMConfigurationResponse {
    return new DeleteOrganizationLLMConfigurationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteOrganizationLLMConfigurationResponse | PlainMessage<DeleteOrganizationLLMConfigurationResponse> | undefined, b: DeleteOrganizationLLMConfigurationResponse | PlainMessage<DeleteOrganizationLLMConfigurationResponse> | undefined): boolean {
    return proto3.util.equals(DeleteOrganizationLLMConfigurationResponse, a, b);
  }
}

/**
 * OrganizationLLMConfiguration contains metadata about an organization's LLM configuration.
 * For security reasons, the actual API key is never returned.
 *
 * @generated from message gitpod.v1.OrganizationLLMConfiguration
 */
export class OrganizationLLMConfiguration extends Message<OrganizationLLMConfiguration> {
  /**
   * organization_id is the ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * provider is the LLM provider (e.g., "anthropic")
   *
   * @generated from field: string provider = 2;
   */
  provider = "";

  /**
   * created_at is when the configuration was first created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is when the configuration was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;

  constructor(data?: PartialMessage<OrganizationLLMConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.OrganizationLLMConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "updated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrganizationLLMConfiguration {
    return new OrganizationLLMConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrganizationLLMConfiguration {
    return new OrganizationLLMConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrganizationLLMConfiguration {
    return new OrganizationLLMConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: OrganizationLLMConfiguration | PlainMessage<OrganizationLLMConfiguration> | undefined, b: OrganizationLLMConfiguration | PlainMessage<OrganizationLLMConfiguration> | undefined): boolean {
    return proto3.util.equals(OrganizationLLMConfiguration, a, b);
  }
}

/**
 * The organization is inferred from the caller's identity.
 * No parameters required.
 *
 * @generated from message gitpod.v1.GetOrganizationLLMUsageRequest
 */
export class GetOrganizationLLMUsageRequest extends Message<GetOrganizationLLMUsageRequest> {
  constructor(data?: PartialMessage<GetOrganizationLLMUsageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetOrganizationLLMUsageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrganizationLLMUsageRequest {
    return new GetOrganizationLLMUsageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrganizationLLMUsageRequest {
    return new GetOrganizationLLMUsageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrganizationLLMUsageRequest {
    return new GetOrganizationLLMUsageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrganizationLLMUsageRequest | PlainMessage<GetOrganizationLLMUsageRequest> | undefined, b: GetOrganizationLLMUsageRequest | PlainMessage<GetOrganizationLLMUsageRequest> | undefined): boolean {
    return proto3.util.equals(GetOrganizationLLMUsageRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetOrganizationLLMUsageResponse
 */
export class GetOrganizationLLMUsageResponse extends Message<GetOrganizationLLMUsageResponse> {
  /**
   * usage_data_from is when usage tracking started for this organization
   * Typically when Ona Intelligence was enabled (organization_llm_integration.created_at)
   *
   * @generated from field: google.protobuf.Timestamp usage_data_from = 1;
   */
  usageDataFrom?: Timestamp;

  /**
   * last_calculated_at is when this usage data was last fetched and calculated
   * Helps users understand data freshness (typically 5-10 minutes behind real-time)
   *
   * @generated from field: google.protobuf.Timestamp last_calculated_at = 2;
   */
  lastCalculatedAt?: Timestamp;

  /**
   * this_week contains usage summary for the last 7 days
   *
   * @generated from field: gitpod.v1.LLMUsageSummary this_week = 3;
   */
  thisWeek?: LLMUsageSummary;

  /**
   * this_month contains usage summary for the last 30 days
   *
   * @generated from field: gitpod.v1.LLMUsageSummary this_month = 4;
   */
  thisMonth?: LLMUsageSummary;

  /**
   * this_year contains usage summary from Ona Intelligence activation to now (max 365 days)
   *
   * @generated from field: gitpod.v1.LLMUsageSummary this_year = 5;
   */
  thisYear?: LLMUsageSummary;

  constructor(data?: PartialMessage<GetOrganizationLLMUsageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetOrganizationLLMUsageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "usage_data_from", kind: "message", T: Timestamp },
    { no: 2, name: "last_calculated_at", kind: "message", T: Timestamp },
    { no: 3, name: "this_week", kind: "message", T: LLMUsageSummary },
    { no: 4, name: "this_month", kind: "message", T: LLMUsageSummary },
    { no: 5, name: "this_year", kind: "message", T: LLMUsageSummary },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrganizationLLMUsageResponse {
    return new GetOrganizationLLMUsageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrganizationLLMUsageResponse {
    return new GetOrganizationLLMUsageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrganizationLLMUsageResponse {
    return new GetOrganizationLLMUsageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrganizationLLMUsageResponse | PlainMessage<GetOrganizationLLMUsageResponse> | undefined, b: GetOrganizationLLMUsageResponse | PlainMessage<GetOrganizationLLMUsageResponse> | undefined): boolean {
    return proto3.util.equals(GetOrganizationLLMUsageResponse, a, b);
  }
}

/**
 * LLMUsageSummary contains aggregated LLM usage data for a specific time period
 *
 * @generated from message gitpod.v1.LLMUsageSummary
 */
export class LLMUsageSummary extends Message<LLMUsageSummary> {
  /**
   * credits_consumed is the total Ona credits consumed in this period
   *
   * @generated from field: double credits_consumed = 1;
   */
  creditsConsumed = 0;

  /**
   * daily_breakdown contains per-day usage data for charting
   *
   * @generated from field: repeated gitpod.v1.DailyUsage daily_breakdown = 2;
   */
  dailyBreakdown: DailyUsage[] = [];

  constructor(data?: PartialMessage<LLMUsageSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.LLMUsageSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "credits_consumed", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "daily_breakdown", kind: "message", T: DailyUsage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LLMUsageSummary {
    return new LLMUsageSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LLMUsageSummary {
    return new LLMUsageSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LLMUsageSummary {
    return new LLMUsageSummary().fromJsonString(jsonString, options);
  }

  static equals(a: LLMUsageSummary | PlainMessage<LLMUsageSummary> | undefined, b: LLMUsageSummary | PlainMessage<LLMUsageSummary> | undefined): boolean {
    return proto3.util.equals(LLMUsageSummary, a, b);
  }
}

/**
 * DailyUsage contains usage data for a single day
 *
 * @generated from message gitpod.v1.DailyUsage
 */
export class DailyUsage extends Message<DailyUsage> {
  /**
   * date is the start of the day (midnight UTC)
   *
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp;

  /**
   * credits_consumed is the number of Ona credits consumed on this day
   *
   * @generated from field: double credits_consumed = 2;
   */
  creditsConsumed = 0;

  constructor(data?: PartialMessage<DailyUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DailyUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date", kind: "message", T: Timestamp },
    { no: 2, name: "credits_consumed", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DailyUsage {
    return new DailyUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DailyUsage {
    return new DailyUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DailyUsage {
    return new DailyUsage().fromJsonString(jsonString, options);
  }

  static equals(a: DailyUsage | PlainMessage<DailyUsage> | undefined, b: DailyUsage | PlainMessage<DailyUsage> | undefined): boolean {
    return proto3.util.equals(DailyUsage, a, b);
  }
}

